import { datalabHttp } from '@dbl/services/common';

import { prepareSaveChartRequest } from './transformers';
import type {
  ISaveChartPayloadMap,
  ISaveChartRequest,
  ISaveChartResponse,
  TSaveChartKind,
} from './types';

/**
 * createChart（wire 请求体）。
 *
 * 迁移期兼容入口：调用方可继续传 snake_case wire body。
 */
export const saveChart = (props: ISaveChartRequest): Promise<ISaveChartResponse> =>
  datalabHttp({
    url: '/api/v1/datalab/createChart',
    method: 'post',
    data: props,
    rawData: true,
  });

/**
 * createChart（VO 包装版）。
 *
 * 见名知意：输入结构化片段（VO），内部执行 `prepareSaveChartRequest` 再发请求。
 * kind + 上传参数 → prepare → HTTP。
 */
export const saveChartVo = <K extends TSaveChartKind>(
  kind: K,
  payload: ISaveChartPayloadMap[K],
): Promise<ISaveChartResponse> => saveChart(prepareSaveChartRequest(kind, payload));
